"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M16,6 C16.05711,6 15.996173,12.62125 16,16 L10,16 L10,10 L6,10 L6,16 L0,16 C-4.22079906e-16,12.6102512 0.00586351879,5.99480953 0,6 C2.70234151,3.97546884 7.96543598,0.0247165323 8,0 C8.54240623,0.40677233 16,6 16,6 Z"
  }));
};

exports["default"] = _default;